import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onSubmit"]

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";
import { auth } from "@/firebase-service";
import { updateEmail } from "@firebase/auth";
import { onMounted, ref, watch } from "vue";
import { useAuth } from "@vueuse/firebase/useAuth";
import { close, settings } from "ionicons/icons";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPage',
  setup(__props) {

const { user } = useAuth(auth);
const router = useRouter();
const tempMail = ref<string | null>("");
if (user.value) {
  tempMail.value = user.value.email;
}

watch(user, () => {
  if (user.value) {
    tempMail.value = user.value.email;
  }
});

async function submitForm() {
  console.log(tempMail.value);
  if (auth.currentUser && tempMail.value) {
    try {
      await updateEmail(auth.currentUser, tempMail.value);
    } catch (e) {
      console.log(e);
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Einstellungen")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(close)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, [
            (_unref(user))
              ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode("Email")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      modelValue: tempMail.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tempMail).value = $event)),
                      type: "email"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonButton), {
              type: "submit",
              fill: "clear"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Email Adresse ändern")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(auth).signOut())),
              fill: "clear"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Logout")
              ]),
              _: 1
            })
          ], 40, _hoisted_1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})